import { Table } from "antd";
import moment from "moment";
import React from "react";
import { totalTimeOrScore } from "../../helper/scoreCounter";
import { AnswerContext } from "../../store/answerStore";
import "./testSummary.scss";

export const CalibrationTestSum = ({ questions }) => {
  console.log("questionsquestions", questions);
  const { answerC, dispatchAnswer } = AnswerContext();

  const getFilSecName = (name) => {
    let pSectionName;
    if (/[:]/.test(name)) {
      pSectionName = name.split(":");
    } else {
      console.log("datadata not any colon is there");
      pSectionName = name.split("- ");
    }
    return pSectionName[1];
  };

  let mySectionArr = answerC.answers.map((myAns) => {
    return myAns.section_name;
  });

  const mySections = mySectionArr.reduce(function (accumulator, currentValue) {
    if (accumulator.indexOf(currentValue) === -1) {
      accumulator.push(currentValue);
    }
    return accumulator;
  }, []);

  const getAllAns = () => {
    let allMyAns = [];

    const dualNBack1 = {
      answer: "",
      file_encoded: "",
      file_path: "",
      file_type: "",
      json_res: "",
      que_id: "118621",
      que_score: 0,
      que_time: 0,
      section_name: "M: DUAL N-BACK 1",
    };

    const fnAns = {
      answer: "",
      file_encoded: "",
      file_path: "",
      file_type: "",
      json_res: "",
      que_id: "118621",
      que_score: 0,
      que_time: 0,
      section_name: "FACE-NAME MIX",
    };

    const cptAns = {
      answer: "",
      file_encoded: "",
      file_path: "",
      file_type: "",
      json_res: "",
      que_id: "118621",
      que_score: 0,
      que_time: 0,
      section_name: "CONTINUOUS PERFORMANCE",
    };

    answerC.answers.forEach((myAns, index) => {
      const trimSecName = getFilSecName(myAns.section_name)
        ? getFilSecName(myAns.section_name).trim()
        : myAns.section_name.trim();
      if ("DUAL N-BACK 1" === trimSecName) {
        dualNBack1.que_score = dualNBack1.que_score + myAns.que_score;
        dualNBack1.answer = `Correct ${Math.sign(
          Math.sign(parseInt(dualNBack1.que_score)) === -1
            ? 0
            : dualNBack1.que_score
        )}`;
      }
      if ("FACE-NAME MIX" === trimSecName) {
        fnAns.que_score = fnAns.que_score + myAns.que_score;
        fnAns.answer = `Correct ${fnAns.que_score}`;
      }
      if ("CONTINUOUS PERFORMANCE" === trimSecName) {
        cptAns.que_score = cptAns.que_score + myAns.que_score;
        cptAns.answer = `Correct ${cptAns.que_score}`;
      }
      if (
        "FACE-NAME MIX" === myAns.section_name ||
        "DUAL N-BACK 1" === trimSecName ||
        "CONTINUOUS PERFORMANCE" === trimSecName
      ) {
        return;
      } else {
        allMyAns = [...allMyAns, myAns];
      }
    });

    // console.log("allMyAns before", allMyAns);

    // allMyAns = !!cptAns.answer ? allMyAns.splice(3, 0, cptAns) : allMyAns;
    allMyAns = !!fnAns.answer ? [fnAns, ...allMyAns] : allMyAns;
    allMyAns = !!dualNBack1.answer ? [dualNBack1, ...allMyAns] : allMyAns;

    if (!!cptAns.answer) {
      allMyAns.splice(4, 0, cptAns);
    } else {
      return allMyAns;
    }
    // console.log("allMyAns after", allMyAns);
    return allMyAns;
  };

  const getAns = (answer) => {
    if (!!answer.timeSpendSound && !!answer.timeSpendSound) {
      return {
        ans: `${Math.floor(answer.averageTimeSpend)} ms`,
        score: answer.totalScore,
      };
    }
    // Special Case for simple React and choice Reaction
    else if (answer.answer === "RT") {
      return {
        ans: answer.que_time ? `${Math.floor(answer.que_time)} ms` : 0,
        score: answer.que_score ? `${Math.floor(answer.que_score)}` : 0,
      };
    } else {
      return {
        ans: !!answer.answer ? answer.answer : "NA",
        score: !!answer.que_score
          ? parseFloat(answer.que_score.toFixed(2).toString())
          : 0,
      };
    }
  };

  const columns = [
    {
      title: "Item",
      dataIndex: "que",
      key: "que",
      align: "left",
    },
    {
      title: "Response",
      dataIndex: "answer",
      key: "answer",
      align: "left",
    },
    {
      title: "Score",
      dataIndex: "score",
      key: "score",
      align: "left",
    },
  ];

  const getScore = (myAns) => {
    return Math.sign(parseInt(getAns(myAns).score)) === -1
      ? 0
      : getAns(myAns).score;
  };

  const dataSetSec = mySections.map((secName, indexS) => {
    let total = 0;
    let ansObj = {
      que: !!getFilSecName(secName) ? getFilSecName(secName) : secName,
      score: "Total" + total,
      key: indexS,
      children: [],
    };
    getAllAns().forEach((myAns, index) => {
      if (secName.trim() === myAns.section_name.trim()) {
        total = total + getScore(myAns);
        ansObj = {
          ...ansObj,
          score: `${total}`,
          children: [
            ...ansObj.children,
            {
              key: `${indexS}${index}`,
              que: index + 1,
              answer: getAns(myAns).ans,
              score: getScore(myAns),
            },
          ],
        };
      }
    });
    return ansObj;
  });

  return (
    <Table
      tableLayout="fixed"
      // dataSource={dataSource()}
      // defaultExpandAllRows={true}
      dataSource={dataSetSec}
      columns={columns}
      pagination={false}
      className="summaryTable cal"
      scroll={{
        y: 360,
      }}
      title={() => {
        return (
          <div className="summary-header">
            <div className="summary-header-left">
              <p>
                {questions[0].test_id === "190425225058"
                  ? "Processing Efficiency"
                  : questions[2].test_id === "190425225056"
                  ? "Memory Processes"
                  : questions[0].test_id === "190425225055"
                  ? "Acquired Knowledge"
                  : questions[0].test_id === "190425225057"
                  ? "Perceptual Processes"
                  : questions[0].test_id === "190425225059"
                  ? "Reasoning Ability"
                  : "MAPPR Mini"}
              </p>
              <p>Test date: {moment().format("DD-MMM-YYYY")} </p>
            </div>
            <div className="summary-header-right">
              <p>{totalTimeOrScore(answerC.answers, questions).player_score}</p>
              <p>score</p>
            </div>
          </div>
        );
      }}
    />
  );
};
